import React, { ChangeEvent } from 'react';
import { AdminProductAttributeListWithOptions_adminProductAttributes, ProductAttributeType } from '@api/graphql/types';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';

interface Props {
    attributes: AdminProductAttributeListWithOptions_adminProductAttributes[];
    attributeOptionIds: Array<(string | null)>;
    onAdd: (value: string) => void;
}

interface State {
    attributeId: string | null;
    optionId: string | null;
}

class ProductAttributeOptionForm extends React.Component<Props & InjectedIntlProps, State> {
    public state = {
        attributeId: '',
        optionId: '',
    };

    private renderOptions() {
        if (!this.state.attributeId) {
            return '';
        }
        const attribute = this.props.attributes.find((attr) => attr.id === this.state.attributeId);
        if (!attribute || !attribute.options) {
            return '';
        }
        return attribute.options.filter((option) => !this.props.attributeOptionIds.includes(option.id)).map((option) => {
            return (
                <option key={option.id} value={option.id}>{option.label}</option>
            );
        });
    }

    private onAdd = () => {
        this.props.onAdd(this.state.optionId);
        this.setState({attributeId: '', optionId: ''});
    }

    private renderEmptyOption() {
        return (
            <option value="">{this.props.intl.formatMessage({id: 'common.emptyOption'})}</option>
        );
    }

    public render() {
        const availableAttributes = this.props.attributes.filter((attribute) => {
            return attribute.type === ProductAttributeType.MULTIPLE ||
                (attribute.options && !attribute.options.some((option) => this.props.attributeOptionIds.includes(option.id)));
        });

        return (
            <div className="row form-row">
                <div className="col-sm-5">
                    <select className="form-control" value={this.state.attributeId} onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                        this.setState({attributeId: e.currentTarget.value, optionId: ''});
                    }}>
                        {this.renderEmptyOption()}
                        {availableAttributes.map((attribute) => {
                            return (
                                <option key={attribute.id} value={attribute.id}>{attribute.name}</option>
                            );
                        })}
                    </select>
                </div>
                <div className="col-sm-5">
                    <select className="form-control" disabled={!this.state.attributeId}onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                        this.setState({optionId: e.currentTarget.value});
                    }}>
                        {this.renderEmptyOption()}
                        {this.renderOptions()}
                    </select>
                </div>
                <div className="col-sm-2">
                    <button className="btn btn-primary btn-block" disabled={!this.state.optionId} onClick={this.onAdd}>{this.props.intl.formatMessage({id: 'common.add'})}</button>
                </div>
            </div>
        );
    }
}

export default compose(injectIntl)(ProductAttributeOptionForm);



// WEBPACK FOOTER //
// ./src/modules/Product/components/ProductAttributeOptionForm.tsx